// extracted by mini-css-extract-plugin
export default {"scroll_button":"scroll_button","scroll_button_vertical":"scroll_button_vertical","scroll_content":"scroll_content","scroll_content_vertical":"scroll_content_vertical"};